// extracted by mini-css-extract-plugin
export var numpadContainer = "_fw-1";
export var phoneButton = "_fw-0";